import { createSlice,current } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  items: [],
  pay:0,
  totalPurchaseAmount:0,
};

export const purchaseSlice = createSlice({
  name: "purchase",
  initialState,
  reducers: {
    selectForPurchase: (state, action) => {
      state.items = action.payload;
    },
    payValue: (state, action) => {
      state.pay = action.payload;
    },
    totalPurchaseAmount:(state,action)=> {
     state.totalPurchaseAmount = action.payload
    },
    editSelForPurchase: (state, action) => {
      const { _id, price } = action.payload;
      let index = state.items.findIndex((item) => item._id == _id);
      state.items[index].companyPrice = price;
    },
    editSelected: (state, action) => {
      const { name, index, value ,steelWeightKgSale, batch  } = action.payload;
      console.log("value:", value);
      console.log("name:", name);
      console.log("index:", index);
      console.log("batch:",  batch );


      console.log("packvlaue:", steelWeightKgSale );

      // let index = state.items.findIndex((item) => item._id == _id);
      // state.items[index].companyPrice = price;

      if (name == "batchNo") {
        console.log("value:", value);
        if (value) {
          // let found = state?.items[index]?.batchNumber?.find(
          //   (i) => i.batchNumber == value
          // );
          // state.items[index].batchNumber = value;
          // state.items[index].batchQty = found.quantity;
          // state.items[index].batchExpiry = moment(found.expiryDate).format(
          //   "DD-MM-YYYY"
          // );
          console.log("ssssss", state.items)
          if (!Array.isArray(state.items[index-1].batchNumber) || !state.items[index-1].batchNumber) {
            state.items[index-1].batchNumber = [];
          }
          state.items[index-1].batchNumber.push(value);


        } else {
          state.items[index].batchNo = null;
          state.items[index].batchQty = null;
          state.items[index].batchExpiry = null;
        }
      } else if(batch) {
        if ((state.items[0].batchNumber.length > 0)) { 
          console.log('stateee', state.items);
          state.items[0].batchNumber = [...state.items[0].batchNumber, batch];

        }

      } else if (name == "purchaseType") {
        state.items[index].purchaseType = value;

      }
      else {
        console.log('before ss', state.items)

        if(steelWeightKgSale) {
          console.log('sss', state.items)
          state.items[index]["steelWeightKgPurchase"] = steelWeightKgSale ;

        }
        state.items[index][name] = value;
      }
    },
    addToSelected: (state, action) => {
      // state.items.push(action.payload);
      if (state.items.length > 0) {
        let found = state.items.find((i) => i._id == action.payload._id);
        if (found) {
          // found.newQuantity;
          if (found.newQuantity) {
            found.newQuantity += parseInt(found.newQuantity) + 1;
          } else {
            found.newQuantity = 2;
          }
        } else {
          state.items.push(action.payload);
        }
      } else {
        state.items.push(action.payload);
      }
    },
    increasePurchaseQty: (state, action) => {
      const { _id } = action.payload;
      console.log('_id', _id)
      let copy = JSON.parse(JSON.stringify(current(state.items)));
      console.log('copy', copy)
      let found = copy.find((item) => item._id == _id);
      console.log('found', found)
      if (found) {
        // found.newQuantity += 1;
        found.newQuantity = (parseInt(found.newQuantity) || 0) + 1;
        console.log('found in if:', found);
        state.items = copy;
      } else {
        let item = JSON.parse(JSON.stringify(action.payload));
        item.newQuantity = 1;
        state.items.unshift(item);
      }
    },
    itemSelection: (state, action) => {
      const { index, value, key } = action.payload;
      state.items[index][key] = value;
    },
    toRemoveItem: (state, action) => {
      let id = action.payload;
      let found = state.items.findIndex((i) => i._id == id);
      state.items.splice(found, 1);
    },
    toRemoveItems: (state) => {
      state.items = [];
    },
    
  },
});

export const {
  editSelForPurchase,
  selectForPurchase,
  itemSelection,
  toRemoveItem,
  addToSelected,
  toRemoveItems,
  editSelected,
  payValue,
  increasePurchaseQty,
  totalPurchaseAmount
} = purchaseSlice.actions;

export default purchaseSlice.reducer;
